<template>
    <client-page>

        <sub-visual
        sh="What We Do"
        tabActive="Overview"
        bg="/images/sub/visual/sv4.png">
        </sub-visual>

        <section class="sub-section--first sub-section--last">
            <v-container>

                <h2 class="page-tit">
                    Overview
                </h2>

                <overview
                src="/images/sub/wwd/overview/overview-img1.png"
                icon="/images/sub/wwd/overview/overview-icon1.png"
                iconWidth="67"
                num="01"
                tit="고객상담">
                    고객의 아이디어를 반영한 맞춤 제작을 통해 <br class="d-none d-lg-block">
                    최적의 방법으로 제품 생산이 가능한 방안을 제시해 드립니다.
                </overview>

                <overview
                className="reverse"
                src="/images/sub/wwd/overview/overview-img2.png"
                icon="/images/sub/wwd/overview/overview-icon2.png"
                iconWidth="55"
                num="02"
                tit="설계 및 소재 선정">
                    반도체 부품 분야에서 핵심 역량을 다져온 기술력을 바탕으로, 구조 특성을 <br class="d-none d-lg-block">
                    이해한 설계 및 다양한 소재의 선정을 통한 제품 커스텀 마이징이 가능합니다.
                </overview>

                <overview
                src="/images/sub/wwd/overview/overview-img3.png"
                icon="/images/sub/wwd/overview/overview-icon3.png"
                iconWidth="54"
                num="03"
                tit="정밀 가공">
                    다양한 정밀 가공 설비를 활용한 순차적 가공 프로세스를 거친 <br class="d-none d-lg-block">
                    퀄리티 높은 상품을 생산합니다.
                </overview>

                <overview
                className="reverse"
                src="/images/sub/wwd/overview/overview-img4.png"
                icon="/images/sub/wwd/overview/overview-icon4.png"
                iconWidth="54"
                num="04"
                tit="정밀 연마">
                    정밀 연마 가공을 통해 고객이 원하는 최적의 제품을 생산합니다. <br>
                    (CMP 공정에 특화된 연마 공정)
                </overview>

                <overview
                src="/images/sub/wwd/overview/overview-img5.png"
                icon="/images/sub/wwd/overview/overview-icon5.png"
                iconWidth="54"
                num="05"
                tit="품질 검사">
                    3D 측정기, 정밀 조도 측정기, 마이크로 스코프 등 품질 관리에 필요한 <br class="d-none d-lg-block">
                    측정기를 보유하고 있으며, SPC를 통한 주기적인 트렌드 분석 및 <br class="d-none d-lg-block">
                    제품 관리에 엄격히 진행하고 있습니다.
                </overview>

                <overview
                className="reverse"
                src="/images/sub/wwd/overview/overview-img6.png"
                icon="/images/sub/wwd/overview/overview-icon6.png"
                iconWidth="55"
                num="06"
                tit="적용 테스트">
                    내·외부 설비를 이용한 검증 테스트 후, 고객사 내부 테스트를 <br class="d-none d-lg-block">
                    진행하여 제품이 적합 여부를 확인합니다.
                </overview>

                <overview
                src="/images/sub/wwd/overview/overview-img7.png"
                icon="/images/sub/wwd/overview/overview-icon7.png"
                iconWidth="54"
                num="07"
                tit="고객 제품 양산">
                    고객이 요구하는 제품의 품질 및 납기를 위해 최선을 다합니다
                </overview>

            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import Overview from "@/components/client/ko/sub/sub-overview.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        Overview,
    },
};
</script>

<style lang="scss" scoped>
.overwiew-item:not(:last-child){
    margin-bottom: 30px;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .overwiew-item:not(:last-child){
        margin-bottom: 60px;
    }
}
@media (min-width:1200px){
}

</style>